
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireed62"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireed62"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4sscG", function(module, exports) {

var $7TZOz = parcelRequire("7TZOz");
window.addEventListener("load", ()=>{
    // window.scrollTo(0, 0);
    (0, $7TZOz.hideLoader)();
});

});
parcelRegister("7TZOz", function(module, exports) {

$parcel$export(module.exports, "showLoader", () => $5c0d9e93748f353d$export$56525cbb1fcd885c);
$parcel$export(module.exports, "hideLoader", () => $5c0d9e93748f353d$export$5cee2c2772922923);
parcelRequire("eVNeL");
var $cPS0R = parcelRequire("cPS0R");
var $GmQs1 = parcelRequire("GmQs1");
function $5c0d9e93748f353d$export$56525cbb1fcd885c() {
    (0, $GmQs1.default).body.classList.add("isLoading");
    (0, $cPS0R.showElement)((0, $GmQs1.default).loader);
}
function $5c0d9e93748f353d$export$5cee2c2772922923() {
    (0, $GmQs1.default).body.classList.remove("isLoading");
    (0, $cPS0R.hideElement)((0, $GmQs1.default).loader);
}

});
parcelRegister("eVNeL", function(module, exports) {

$parcel$export(module.exports, "refs", () => (parcelRequire("GmQs1")).default);
$parcel$export(module.exports, "showElement", () => (parcelRequire("cPS0R")).showElement);
$parcel$export(module.exports, "hideElement", () => (parcelRequire("cPS0R")).hideElement);

var $GmQs1 = parcelRequire("GmQs1");

var $cPS0R = parcelRequire("cPS0R");

});
parcelRegister("GmQs1", function(module, exports) {

$parcel$export(module.exports, "default", () => $07f5a4e5854dd40e$export$2e2bcd8739ae039);
const $07f5a4e5854dd40e$var$refs = {
    body: document.querySelector("body"),
    header: document.querySelector("header"),
    loader: document.querySelector(".loader")
};
var $07f5a4e5854dd40e$export$2e2bcd8739ae039 = $07f5a4e5854dd40e$var$refs;

});

parcelRegister("cPS0R", function(module, exports) {

$parcel$export(module.exports, "hideElement", () => $9584254497e9709d$export$7669482c90f5c50f);
$parcel$export(module.exports, "showElement", () => $9584254497e9709d$export$998191bfdf710c72);
function $9584254497e9709d$export$7669482c90f5c50f(el) {
    el.classList.add("isHidden");
    el.setAttribute("aria-hidden", "true");
}
function $9584254497e9709d$export$998191bfdf710c72(el) {
    el.classList.remove("isHidden");
    el.setAttribute("aria-hidden", "false");
}

});




parcelRegister("c9fKA", function(module, exports) {
parcelRequire("eVNeL");
var $cPS0R = parcelRequire("cPS0R");
const $8d828af966f1ebc3$var$mobileMenuRefs = {
    menu: document.querySelector(".mobile-menu"),
    btnOpen: document.querySelector(".mobile-menu__btn")
};
$8d828af966f1ebc3$var$mobileMenuRefs.btnOpen.addEventListener("click", $8d828af966f1ebc3$var$toggleBurgerMenu);
$8d828af966f1ebc3$var$mobileMenuRefs.menu.addEventListener("click", $8d828af966f1ebc3$var$toggleBurgerMenu);
function $8d828af966f1ebc3$var$toggleBurgerMenu() {
    const expanded = $8d828af966f1ebc3$var$mobileMenuRefs.btnOpen.getAttribute("aria-expanded") === "true" || false;
    if (expanded) (0, $cPS0R.hideElement)($8d828af966f1ebc3$var$mobileMenuRefs.menu);
    else (0, $cPS0R.showElement)($8d828af966f1ebc3$var$mobileMenuRefs.menu);
    $8d828af966f1ebc3$var$mobileMenuRefs.btnOpen.setAttribute("aria-expanded", !expanded);
    document.body.classList.toggle("mobileMenuIsOpen");
}

});

parcelRequire("4sscG");
parcelRequire("c9fKA");
const $89be16c2b583eab2$var$appsListRef = document.querySelector(".apps__list");
$89be16c2b583eab2$var$appsListRef.addEventListener("click", $89be16c2b583eab2$var$onListClick);
function $89be16c2b583eab2$var$onListClick(e) {
    if (e.target.classList.contains("app__btn-details")) {
        const element = e.target?.closest(".app");
        const elementExtraContent = element?.querySelector(".app__desc");
        const elementBtn = element?.querySelector(".app__btn-details");
        if (elementExtraContent.style.maxHeight) elementExtraContent.style.maxHeight = null;
        else elementExtraContent.style.maxHeight = elementExtraContent.scrollHeight + "px";
        const expanded = elementBtn.getAttribute("aria-expanded") === "true" || false;
        elementBtn.setAttribute("aria-expanded", !expanded);
        elementBtn?.classList.toggle("isActive");
    }
}


new Swiper(".apps-swiper--1", {
    navigation: {
        prevEl: ".apps-swiper--1 .apps-swiper-btn-prev",
        nextEl: ".apps-swiper--1 .apps-swiper-btn-next"
    },
    pagination: {
        el: ".apps-swiper--1 .apps-swiper-pagination",
        clickable: true
    },
    keyboard: {
        enabled: true,
        onlyInViewport: true
    },
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 28,
    speed: 800,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    loop: true,
    freeMode: true
});
new Swiper(".apps-swiper--2", {
    navigation: {
        prevEl: ".apps-swiper--2 .apps-swiper-btn-prev",
        nextEl: ".apps-swiper--2 .apps-swiper-btn-next"
    },
    pagination: {
        el: ".apps-swiper--2 .apps-swiper-pagination",
        clickable: true
    },
    keyboard: {
        enabled: true,
        onlyInViewport: true
    },
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 28,
    speed: 800,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    loop: true,
    freeMode: true
});
new Swiper(".apps-swiper--3", {
    navigation: {
        prevEl: ".apps-swiper--3 .apps-swiper-btn-prev",
        nextEl: ".apps-swiper--3 .apps-swiper-btn-next"
    },
    pagination: {
        el: ".apps-swiper--3 .apps-swiper-pagination",
        clickable: true
    },
    keyboard: {
        enabled: true,
        onlyInViewport: true
    },
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 28,
    speed: 800,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    },
    loop: true,
    freeMode: true
});




//# sourceMappingURL=index.5f2d7ca6.js.map
